﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260112
*/
'use strict';

import {
    getErrMsgDivId,
    getPromise,
    savePromise
} from './ctssJQuery.js';
import {
    appDebugMode,
    getAppToken
} from './snSite.js';

const token = getAppToken();

const approveJoinRequestAsync = async (params) => {

    const p = {
        url: 'GroupMembers/ApproveJoinRequests',
        data: params.data,
        divErrMsg: getErrMsgDivId({ divErrMsg: params.divErrMsg })
    }
    if (params.btnId !== undefined) {
        p.btnId = params.btnId;
    }

    return await savePromise(p);
}

const getGroupMembersAsync = async (params) =>
    await getPromise({ url: `GroupMembers/${token.CG}/${params.groupID}` });


const getJoinRequestAsync = async (params) => {

    //const test = [];
    //test.push({ id: 37, name: 'Theresa Baker', email: 'tb@ctsoftwaresystems.com', phone: '(831)357-4232', joinRequestDate: '10/15/2022' });
    //test.push({ id: 44, name: 'George Mansfield', email: 'gm@ctsoftwaresystems.com', phone: '(510)383-4959', joinRequestDate: '10/7/2022' });
    //test.push({ id: 51, name: 'Henry Goode', email: 'hg@ctsoftwaresystems.com', phone: '(913)583-4622', joinRequestDate: '9/27/2022' });
    //test.push({ id: 35, name: 'Clarence Jones', email: 'cj@ctsoftwaresystems.com', phone: '(302)983-6298', joinRequestDate: '9/25/2022' });
    //return test;

    return await getPromise({
        url: `GroupMembers/${token.CG}/JoinRequest/${params.groupID}` /* groupID */
    })
}

const leaveAsync = async (params = {}) => {

    const {
        groupID,
        memberID
    } = params;

    if (!groupID || !memberID) {
        alert('groupID and memberID are required parameters for leaveAsync');
        return
    }

    return await savePromise({
        url: 'GroupMembers/Leave',
        data: { cg: token.CG, groupID, memberID }
    });
}

const saveGroupMembersAsync = async (params) => {

    params.data.cg = token.CG;  

    const p = {
        url: 'GroupMembers',
        data: params.data,
        divErrMsg: getErrMsgDivId({ divErrMsg: params.divErrMsg })
    }
    if (params.btnId !== undefined) {
        p.btnId = params.btnId;
    }

    return await savePromise(p);
}

export {
    approveJoinRequestAsync,
    getGroupMembersAsync,
    getJoinRequestAsync,
    leaveAsync,
    saveGroupMembersAsync
}
